import { useEffect, useRef, useState } from 'react';
import styled, { useTheme } from 'styled-components';
import logo from '../../../assets/images/talents-logo-sm.png';
import { useAuth } from '../../../contexts/authentication.context';
import { screenWidths } from '../../../enums';
import { useMedia } from '../../../hooks';
import configProxy from '../../../utils/config';
import SideDrawerBurger from '../side-drawer/side-drawer-burger/side-drawer-burger';
import NavigationItems from './navigation-items/navigation-items';
import { Link, Route } from 'react-router-dom';

const NavbarContainer = styled.header<{ media: keyof typeof screenWidths }>`
	width: 100%;
	height: auto;
	background-color: ${({ theme }) => theme.NAV_BG};
	position: sticky;
	top: 0;
	left: 0;
	display: flex;
	flex-flow: row;
	justify-content: space-between;
	align-items: center;
	box-sizing: border-box;
	transition: all 0.5s;
	padding: 8px 18px;
	flex-wrap: wrap;
	z-index: 210;

	nav {
		height: 100%;
	}

	&.hide {
		/* position: absolute; */
		top: -100%;
		/* transform: translateY(-100%); */
	}

	@media (min-width: ${({ media }) => screenWidths[media]}) {
		padding: 12px 18px;
		position: sticky;
		flex-wrap: nowrap;
		z-index: 400;
	}
`;

const Navbar = ({ isAuthenticated, onBurgerClick }: any) => {
	let { user } = useAuth();
	const theme = useTheme();
	let navRef = useRef<any>();
	let media = configProxy.defaultExpandScreenSize;
	let desktop = useMedia(media);
	let [navState, setNavState] = useState({
		visible: true,
		lastScrollPos: 0
	});
	const detectScroll = () => {
		let currentScrollPos = window.pageYOffset;
		if (currentScrollPos < navRef?.current?.getBoundingClientRect().height) return;
		setNavState(oldState => {
			return {
				visible: oldState.lastScrollPos > currentScrollPos,
				lastScrollPos: currentScrollPos
			};
		});
	};
	useEffect(() => {
		window.addEventListener('scroll', detectScroll);
		return () => {
			window.removeEventListener('scroll', detectScroll);
		};
	}, []);

	return (
		<NavbarContainer className={!desktop && !navState.visible ? 'hide' : undefined} media={media} ref={navRef}>
			{!isAuthenticated || !user ? null : <SideDrawerBurger onClick={onBurgerClick} media={media} />}

			<div>
				<a
					href={isAuthenticated ? '/' : 'https://talentsarena.net'}
					target={!isAuthenticated ? '_blank' : undefined}
					className={`navbar-brand d-none d-${media}-inline`}
				>
					<img src={theme.HEADER_LOGO} alt="ta-logo" style={{ maxWidth: '200px' }} />
				</a>
			</div>
			<nav>
				<NavigationItems isAuthenticated={isAuthenticated} user={user} media={media} />
			</nav>
		</NavbarContainer>
	);
};

export default Navbar;
